import { Static, Optional, String, Boolean, Object, Array } from '@sinclair/typebox';

import { SavedTraveler } from './travelers';

export type SimpleProfile = Static<typeof SimpleProfile>;
export const SimpleProfile = Object({
  firstName: String(),
  lastName: String(),
  tier: Optional(String()),
});

export type ProfileResponse = Static<typeof ProfileResponse>;
export const ProfileResponse = Object({
  isSignedIn: Boolean(),
  profile: Optional(SimpleProfile),
  savedTravelers: Array(SavedTraveler),
  customerId: Optional(String()),
  customerType: Optional(String()),
  euroBonusNr: Optional(String()),
});
